import { FamilyMember, MedicalConditionPresenter, MedicalConditionStatus } from './types';

interface IncomingProps {
  name: string;
  affectedPeople: FamilyMember[];
}

export class MedicalConditionDelegate {
  private _name: string;
  private _affectedPeople: FamilyMember[];

  public get status(): MedicalConditionStatus {
    return this._affectedPeople.length > 0 ? MedicalConditionStatus.COMPLETED : MedicalConditionStatus.DETAILS_MISSING;
  }

  public get data(): MedicalConditionPresenter {
    return {
      name: this._name,
      affectedPeople: this._affectedPeople,
      status: this.status,
    };
  }

  constructor(props: IncomingProps) {
    this._name = props.name;
    this._affectedPeople = props.affectedPeople;
  }
}
